// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".unlimited[data-v-025ba1e6]{position:absolute;bottom:-14px;font-size:12px}[data-v-025ba1e6] input{margin-right:30px}[data-v-025ba1e6] label{margin-left:12px}[data-v-025ba1e6] .icon-right{margin-right:-20px}", ""]);
// Exports
module.exports = exports;
